import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { toPx } from 'common/builder/components/chart/utils/toPx'

export const NodeContainerDefaultStyles: React.CSSProperties = {
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  borderRadius: toPx(sharedStyles.BorderRadius.LARGE),
  boxShadow: sharedStyles.BoxShadows.NODE,
  // eslint-disable-next-line
  // @ts-expect-error
  backgroundAlpha: 0.85,
  backgroundColor: sharedStyles.Colors.WHITE,
}

export const InputConnectorPointStyle = {
  position: 'absolute',
  top: toPx(sharedStyles.Spacings.EXTRA_LARGE),
  left: 0,
}
